import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

/*
 * Partner/Retailer scoped routes
 */
//const URL_MARKETING_TOOLING = `${URL_RETAILER_SCOPED}/marketing-tooling`

/*
 * Admin routes
 */
const URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS = `${URL_APP_ADMIN}/marketing-tooling/campaigns`
const URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_CREATE = `${URL_APP_ADMIN}/marketing-tooling/campaigns/create`
const URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_EDIT = `${URL_APP_ADMIN}/marketing-tooling/campaigns/:campaignId/edit`
const URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_VIEW = `${URL_APP_ADMIN}/marketing-tooling/campaigns/:campaignId`
// @hygen:inject scoped-urls

export type DashRouteSet =
  // Partner/Retailer scoped routes
  //| DashRouteType<'marketing-tooling'>

  // Admin routes
  | DashRouteType<'app-admin-marketing-tooling-campaigns'>
  | DashRouteType<'app-admin-marketing-tooling-campaigns-create'>
  | DashRouteType<'app-admin-marketing-tooling-campaigns-edit', { campaignId: string }>
  | DashRouteType<'app-admin-marketing-tooling-campaigns-view', { campaignId: string }>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  // Partner/Retailer scoped routes
  //'marketing-tooling': URL_MARKETING_TOOLING,

  // Admin routes
  'app-admin-marketing-tooling-campaigns': URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS,
  'app-admin-marketing-tooling-campaigns-create': URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_CREATE,
  'app-admin-marketing-tooling-campaigns-edit': URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_EDIT,
  'app-admin-marketing-tooling-campaigns-view': URL_ADMIN_MARKETING_TOOLING_CAMPAIGNS_VIEW,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
